/*
 *
 * TopMenu
 *
 */

import React from 'react';
import {
  Wrapper,
  Content,
} from './styledComponents';

const TopMenu = ({ links, children, searchOnChange, searchValue }) => {
  let terms = (children._owner._context.router.route.location.pathname === '/terms');
  return(<Wrapper>
    <Content divPadding={terms ? 200 : 0} >
      {children}
    </Content>
  </Wrapper>
)};

export default TopMenu;



// WEBPACK FOOTER //
// ./src/components/TopMenu/index.js